import classes from "./sidebar.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import logo from "./images/timesavelogo.png";
import {
  AiOutlineAudit,
  AiOutlineWallet,
  AiTwotoneBook,
  AiTwotoneDashboard,
  AiOutlineUser,
  AiOutlineUsergroupAdd,
  AiOutlineTeam,
  AiTwotoneQuestionCircle,
} from "react-icons/ai";
import { useState } from "react";

function Sidebar() {
  const userInfo = localStorage.getItem("user-info");
  const getadmin = JSON.parse(userInfo).data.roles;
  let adminroute = " ";
  const accessbility = JSON.parse(userInfo).data.accessbility;
  const is_super_admin = JSON.parse(userInfo).data.is_super_admin;
  if (getadmin !== "admin" || is_super_admin === "1") {
    adminroute = (
      <li>
        {" "}
        <NavLink to="/admin/adminlisting">
          <span className="nav icon">
            <AiOutlineUser />
          </span>
          <span className="nav"> Create Admin</span>
        </NavLink>{" "}
      </li>
    );
  }
  return (
    <>
      <div className="sidebar">
        <span className="image">
          <img src={logo} alt=" " />
        </span>
        <ul className="sidebardiv">
          <li>
            <NavLink to="/admin/dashboard">
              <span className="nav icon">
                <AiTwotoneDashboard />
              </span>
              <span className="nav">Dashboard</span>
            </NavLink>
          </li>
          {accessbility?.industry.read === 1 ||
          accessbility?.industry.read === true ? (
            <li>
              <NavLink to="/admin/industry">
                <span className="nav icon">
                  <AiTwotoneBook />
                </span>
                <span className="nav"> Industry</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.category.read === 1 ||
          accessbility?.category.read === true ? (
            <li>
              <NavLink to="/admin/category">
                <span className="nav icon">
                  <AiTwotoneBook />
                </span>
                <span className="nav"> Category</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.subcat.read === 1 ||
          accessbility?.subcat.read === true ? (
            <li>
              <NavLink to="/admin/subcategory">
                <span className="nav icon">
                  <AiTwotoneBook />
                </span>
                <span className="nav"> SubCategory</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.que.read === 1 || accessbility?.que.read === true ? (
            <li>
              <NavLink to="/admin/quiz">
                <span className="nav icon">
                  <AiTwotoneQuestionCircle />
                </span>
                <span className="nav"> Questions</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.jobs.read === 1 || accessbility?.jobs.read === true ? (
            <li>
              <NavLink to="/admin/alljobs">
                <span className="nav icon">
                  <AiTwotoneBook />
                </span>
                <span className="nav"> Jobs</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.ufeedback.read === 1 ||
          accessbility?.ufeedback.read === true ? (
            <li>
              <NavLink to="/admin/jobslist">
                <span className="nav icon">
                  <AiTwotoneBook />
                </span>
                <span className="nav"> Users Feedback</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.feedback.read === 1 ||
          accessbility?.feedback.read === true ? (
            <li>
              <NavLink to="/admin/feedback">
                <span className="nav icon">
                  <AiTwotoneBook />
                </span>
                <span className="nav"> Feedback</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.employers.read === 1 ||
          accessbility?.employers.read === true ? (
            <li>
              <NavLink to="/admin/employers">
                <span className="nav icon">
                  <AiOutlineUsergroupAdd />
                </span>
                <span className="nav"> Employers</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.homeowners.read === 1 ||
          accessbility?.homeowners.read === true ? (
            <li>
              <NavLink to="/admin/homeowner">
                <span className="nav icon">
                  <AiOutlineUser />
                </span>
                <span className="nav"> Homeowners</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.providers.read === 1 ||
          accessbility?.providers.read === true ? (
            <li>
              <NavLink to="/admin/provider">
                <span className="nav icon">
                  <AiOutlineTeam />
                </span>
                <span className="nav"> Providers</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.incompleteusers.read === 1 ||
          accessbility?.incompleteusers.read === true ? (
            <li>
              <NavLink to="/admin/incompleteusers">
                <span className="nav icon">
                  <AiOutlineTeam />
                </span>
                <span className="nav"> Incomplete Users</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.credits.read === 1 ||
          accessbility?.credits.read === true ? (
            <li>
              <NavLink to="/admin/credit">
                <span className="nav icon">
                  <AiOutlineWallet />
                </span>
                <span className="nav"> Credit</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {/* {is_super_admin === "1" ? adminroute: <></>} */}
          {adminroute}
          {accessbility?.wallets.read === 1 ||
          accessbility?.credits.read === true ? (
            <li>
              <NavLink to="/admin/wallet">
                <span className="nav icon">
                  <AiOutlineWallet />
                </span>
                <span className="nav"> Wallet</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.auditlogs.read === 1 ||
          accessbility?.auditlogs.read === true ? (
            <li>
              <NavLink to="/admin/audit">
                <span className="nav icon">
                  <AiOutlineAudit />
                </span>
                <span className="nav"> Auditlog</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.about.read === 1 ||
          accessbility?.about.read === true ? (
            <li>
              <NavLink to="/admin/aboutus">
                <span className="nav icon">
                  <AiTwotoneBook />
                </span>
                <span className="nav"> About Us</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.privacy.read === 1 ||
          accessbility?.privacy.read === true ? (
            <li>
              <NavLink to="/admin/privacypolicy">
                <span className="nav icon">
                  <AiTwotoneBook />
                </span>
                <span className="nav"> Privacy Policy</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          {accessbility?.terms.read === 1 ||
          accessbility?.terms.read === true ? (
            <li>
              <NavLink to="/admin/termsandconditions">
                <span className="nav icon">
                  <AiTwotoneBook />
                </span>
                <span className="nav"> Terms &amp; Conditions</span>
              </NavLink>
            </li>
          ) : (
            <></>
          )}
          <li>
            <NavLink to="/admin/rating">
              <span className="nav icon">
                <AiTwotoneBook />
              </span>
              <span className="nav">Rating</span>
            </NavLink>
          </li>
          {(accessbility?.ufeedback.read === 1 || accessbility?.ufeedback.read === true) ? (
          <li>
              <NavLink to="/admin/payouts">
                <span className="nav icon">
                  <AiTwotoneBook />
                </span>
                <span className="nav"> Payouts</span>
              </NavLink>
            </li>
           ) : (
            <></>
          )}
          <li>
            <NavLink to="/admin/approveDocument">
              <span className="nav icon">
                <AiOutlineUser />
              </span>
              <span className="nav">Approve Documents</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/admin/profile">
              <span className="nav icon">
                <AiOutlineUser />
              </span>
              <span className="nav"> Profile</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
}

export default Sidebar;
